import {Component, Input, OnInit} from '@angular/core';
import {AuthenticationService} from '@services/authentification.service';
import {Favorite} from '@models/favorite';
import {CommonService} from '@services/common.service';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-widget-price-evol',
    templateUrl: './price-evol.component.html',
    styleUrls: ['./price-evol.component.scss']
})
export class PriceEvolComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    loading = true;
    user: User = Object.assign({}, EMPTY_USER);
    price_change = 0;
    /**
     * Chart
     */
    columnNames = [
        {label: 'Date', type: 'date'},
        {label: 'Prix', type: 'number'},
        {label: 'Tooltip', type: 'string', role: 'tooltip', p: {html: true}},
        {label: 'Color', type: 'string', role: 'style'},
    ];

    data = {
        series: [],
    };

    options = {
        tooltip: {
            trigger: 'axis',
            /*  formatter: function (params) {
                  params = params[0];
                  var date = new Date(params.name);
                  return date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + ' : ' + params.value[1];
              },*/
            axisPointer: {
                animation: false
            },
            formatter: params => {
                let lib = '';
                params.forEach(d => {
                    const date = new Date(d.data.name);
                    lib += this.commonService.formatDate(date)
                        + ' : ' + Math.round(d.data.value[1]).toLocaleString('fr-FR') + ' €<br/>';
                });
                return lib;
            }
            // formatter: '{b} <br/>{a} : {c} €/m²
        },
        legend: {
            orient: 'vertical',
            right: '40px',
            bottom: '70px',
            align: 'right',
            // data: ['Appartement', 'Maison', 'Appartement Moy', 'Maison Moy']
        },
        grid: {
            left: '4%',
            right: '4%',
            bottom: '12%',
            top: '3%',
            containLabel: true,
        },
        xAxis: {
            type: 'time',
            splitLine: {
                show: false
            },
            axisLabel: {
                formatter: (value => {
                    const date = new Date(value);
                    return this.commonService.formatDate(date);
                })
            },
        },
        yAxis: {
            type: 'value',
            min: 0,
        },
        color: ['#2980B9'],
        series: []
    };

    url = '';

    constructor(
        public authenticationService: AuthenticationService,
        private commonService: CommonService,
        public deviceService: DeviceDetectorService) {
    }

    ngOnInit() {
        this.user = this.authenticationService.currentUser;

        if (this.favorite.ad != null) {
            this.data.series.push({
                name: 'Évolution du prix',
                type: 'line',
                symbolSize: 5,
                step: 'end',
                smooth: false,
                data: []
            });

            if (this.favorite.ad.prices) {
                this.favorite.ad.prices.forEach((price, index) => {
                    if (this.favorite.ad.price - price.price < this.price_change) {
                        this.price_change = this.favorite.ad.price - price.price;
                    }
                    const date = new Date(price.date);
                    this.data.series[0].data.push({
                        name: date.toString(),
                        value: [
                            [date.getFullYear(), date.getMonth() + 1, date.getDate()].join('/'),
                            Math.round(price.price)
                        ]
                    });

                    if (this.options.yAxis.min === 0 || this.options.yAxis.min > (price.price / 1.2)) {
                        this.options.yAxis.min = Math.round(price.price / 1.2 / 10000) * 10000;
                    }
                });
            }
            const today = new Date();
            this.data.series[0].data.push({
                name: today.toString(),
                value: [
                    [today.getFullYear(), today.getMonth() + 1, today.getDate()].join('/'),
                    Math.round(this.favorite.ad.price)
                ]
            });
            this.loading = false;
        }
    }
}
